import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { PageSectionTitle as SectionTitle } from '../';
const UnderReviewTile = () => {
    const { t } = useTranslation('shared');
    return (_jsx("main", { className: "general-message", children: _jsxs("div", { children: [_jsx(SectionTitle, { title: t('common.AnalysisInProgress') }), _jsx("h3", { children: _jsx(Trans, { i18nKey: "common.hasBeenSubmitted", ns: "shared" }) })] }) }));
};
export default UnderReviewTile;
